import React, { useEffect } from "react";
import { connect } from "react-redux";
import * as modalDataService from './modalDataService';
import { debug } from "../../utils";
import * as validationService from "./validationService";


function ApiUrlField({ apiUrl, anotherSectionActive, error }) {

    useEffect(() => {
        if (anotherSectionActive) {
            validationService.cleanValidation('apiUrl');
            onChange('');
        } else {
            validationService.validateUrl(apiUrl, 'apiUrl');
        }
        return () => validationService.cleanValidation('apiUrl');
    }, [apiUrl, anotherSectionActive])

    const onChange = (value) => modalDataService.changeApiUrl(value);

    return (
        <div className="form-group">
            <div className="oct_form-group oct_form-sm">
                <label htmlFor="url">URL <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${error && 'border-danger'}`}
                    id="url"
                    placeholder="https://api.example.com"
                    onChange={(event => onChange(event.target.value))}
                    value={apiUrl} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("ApiUrlField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const validation = state.validation;
    const anotherSectionActive = false;//!!addDeviceModal.apiUsername || !!addDeviceModal.apiPassword
    return {
        apiUrl: addDeviceModal.apiUrl || '',
        error: validation.apiUrl,
        anotherSectionActive
    }
}

export default connect(mapStateToProps)(ApiUrlField);
